@if (parcels().length) {
  <app-accordion-group>
    @for (item of parcels(); track $index) {
      <app-accordion-item
        [expanded]='expanded'
        [name]="$index + 1 + '. Obręb: ' + item?.precinct + ', Nr ewidencyjny: ' + item?.registrationNumber"
        [disabled]='false'>
        @if (parcelId) {
          <div class="row">
            <div class="col-md-5">
              <app-label label="Identyfikator działki:">
                {{ item?.parcelId || '-' }}
              </app-label>
            </div>
          </div>
        }
        <div class="row">
          @if (showIsEntireParcelCoveredByPlan) {
            <div class="col-12">
              <app-label label="Czy teren objęty planem obejmuje całość działki lub działek ewidencyjnych:">
                {{ item?.isEntireParcelCoveredByPlan ? "Tak" : "Nie" }}
              </app-label>
            </div>
          }
          @if (planName) {
            <div class="col-12">
              <app-label label="Nazwa aktu planowania przestrzennego:">
                {{ item?.planName || '-' }}
              </app-label>
            </div>
          }
          @if (item?.content; as content) {
            <div class="col-12">
              <app-label label="Treść:">
                {{ content || '-' }}
              </app-label>
            </div>
          }
          @if (detailedInformation) {
            <div class="col-md-6">
              <app-label
                label="Nazwa lub nazwy klasy przeznaczenia terenu (albo <br> symbol lub symbole klasy przeznaczenia terenu):">
                {{ item?.landUseClass || '-' }}
              </app-label>
            </div>
            <div class="col-md-6">
              <app-label
                label="Maksymalny udział <br> powierzchni zabudowy [%]:">
                {{ item?.maxBuildingCoverage }}
              </app-label>
            </div>
            <div class="col-md-6">
              <app-label
                label="Maksymalna wysokość zabudowy [m]:">
                {{ item?.maxBuildingHeight || '-' }}
              </app-label>
            </div>
            <div class="col-md-6">
              <app-label
                label="Minimalny udział powierzchni biologicznie czynnej [%]:">
                {{ item?.minBiologicalArea || '-' }}
              </app-label>
            </div>
          }
          @if (landUse) {
            <div class="col-12">
              <app-label
                label="Przeznaczenie/ cel podziału:">
                {{ item?.landUseClass || '-' }}
              </app-label>
            </div>
          }
          @if (access) {
            <div class="col-12">
              <app-label
                label="Dojazd:">
                {{ item?.access || '-' }}
              </app-label>
            </div>
          }
        </div>
        <div slot="action">
          @if (showActions()) {
            <button
              (click)='onEdit.emit({ v: item, i: $index }); $event.preventDefault()'
              class='btn btn-secondary icon-btn'
              title='Edytuj'
              type="button"
              [disabled]='!canEdit()'>
              <i class='fa fa-pencil-alt'></i>
            </button>
            &nbsp;
            <button
              [disabled]='!canEdit()'
              type='button'
              class='btn btn-red-secondary icon-btn' title='Usuń z listy'
              (click)='onRemove.emit($index); $event.preventDefault()'>
              <i class='fa fa-trash-alt'></i>
            </button>
          }
        </div>
      </app-accordion-item>
    }
  </app-accordion-group>
} @else {
  <br>
  <app-alert type="info" [closable]="false"><strong>Brak dodanych działek!</strong></app-alert>
}
